import Props from "./props";
import styled from "styled-components";

const TextareaAutogrow = styled.textarea<Props>`
    height: auto;
    resize: none;
    font-weight: 100;
    width: 100%;
    border: none;
    color: ${props => props.theme.colors.black(1)};
    outline: none;
    box-shadow: 0 0 0.2rem ${props => props.theme.colors.primary(1)};
    border-radius: 0.3rem;
`;

export default TextareaAutogrow;
